/**
 * RackPanoramic — OutpostForge frontend
 * Compact overview of a rack: one thin capacity strip per asset ordered by
 * elevation (top of rack first), mirroring the physical layout.
 */

import { useMemo } from 'react';
import { computeAssetSlotting } from '../../services/slotting';
import type { AssetSummary } from '../../types/outposts';
import { CapacityVisual } from './CapacityVisual';
import '../visualizer.css';

function PanoramicRow({ asset }: { asset: AssetSummary }) {
  const slotting = useMemo(() => computeAssetSlotting(asset), [asset]);
  // No visible asset ID: those details live in each asset card below.
  // data-asset-id keeps the elevation order verifiable (E2E contract).
  return (
    <div className="rack-panoramic__row" data-asset-id={asset.assetId}>
      {slotting ? (
        <CapacityVisual layout={slotting.layout} compact />
      ) : (
        <div className="capacity-visual capacity-visual--compact" title="No configuration" />
      )}
    </div>
  );
}

export function RackPanoramic({ assets }: { assets: AssetSummary[] }) {
  return (
    <div className="rack-panoramic" data-testid="rack-panoramic">
      <p className="rack-panoramic__title">Rack overview</p>
      {assets.map((asset) => (
        <PanoramicRow key={asset.assetId} asset={asset} />
      ))}
    </div>
  );
}
